/**
 * Settings > AI Controls. Cards render top to bottom in this order; add new
 * AI admin cards here (CLAUDE.md §3.6).
 */
import React from 'react';
import AIPolicyEditor from '../../../../components/admin/AIPolicyEditor';
import SchoolAiPolicyOverrideCard from '../../../../components/admin/SchoolAiPolicyOverrideCard';
import WorkloadModelRoutingPanel from '../../../../components/admin/WorkloadModelRoutingPanel';
import ClaudeGatewayCard from '../../../../components/admin/ClaudeGatewayCard';
import FeatureToggleCard from '../../../../components/admin/FeatureToggleCard';
import GradingConfigurationPanel from '../../../../components/admin/GradingConfigurationPanel';
import type { FeatureToggleState } from '../hooks/useFeatureToggle';

interface AiSettingsSectionProps {
  chatStreaming: FeatureToggleState;
  analysisStreaming: FeatureToggleState;
  agenticChat: FeatureToggleState;
}

export default function AiSettingsSection({
  chatStreaming,
  analysisStreaming,
  agenticChat,
}: AiSettingsSectionProps) {
  return (
    <>
      {/* Platform Default AI Policy */}
      <AIPolicyEditor mode="platform" title="Platform Default AI Policy" />

      {/* School AI Policy Override */}
      <SchoolAiPolicyOverrideCard />

      {/* Claude API spend cap + force-OpenRouter kill switch */}
      <ClaudeGatewayCard />

      <WorkloadModelRoutingPanel />

      <FeatureToggleCard
        title="Chat Streaming"
        description="Enable real-time token streaming for chat responses. When enabled, users see text appear progressively instead of waiting for the full response."
        enableLabel="Enable Streaming"
        disableLabel="Disable Streaming"
        enabled={chatStreaming.enabled}
        loading={chatStreaming.loading}
        onToggle={chatStreaming.toggle}
      />

      <FeatureToggleCard
        title="Analysis Streaming"
        description="Enable real-time streaming for Phase 3 analysis. When enabled, users see the analysis narrative build progressively in the progress modal instead of waiting for the full response."
        enableLabel="Enable Streaming"
        disableLabel="Disable Streaming"
        enabled={analysisStreaming.enabled}
        loading={analysisStreaming.loading}
        onToggle={analysisStreaming.toggle}
      />

      <FeatureToggleCard
        title="Agentic Mentor Chat"
        description="Enable tool-augmented agentic chat for mentors. When enabled, the mentor chat session uses AI tools (session recap, curriculum lookup, goal progress) instead of the standard context window."
        enableLabel="Enable Agentic Chat"
        disableLabel="Disable Agentic Chat"
        enabled={agenticChat.enabled}
        loading={agenticChat.loading}
        onToggle={agenticChat.toggle}
      />

      {/* AI Grading Configuration */}
      <GradingConfigurationPanel />
    </>
  );
}
